<template>
  <CustomPage noTitle>
    <div slot="content" style="height: 100%">
      <div class="text-center">
        <Item
          :loading="loading"
          :purchaseList="purchaseList"
          :invalidGoodsList="invalidGoodsList"
          :totalNum="totalNum"
          :vaildCommoditiesNum="vaildCommoditiesNum"
          @handleTotalNum="handleTotalNum"
          @freshCart="freshCart"
        ></Item>
        <CustomView />
        <Tabbar />
      </div></div
  ></CustomPage>
</template>

<script>
import CustomPage from "@/components/custom-page.vue";
import CustomView from "@/components/custom-view.vue";
import Item from "./components/Item.vue";
import Tabbar from "@/components/Tabbar";
import { getCart } from "./webApi";
export default {
  components: { CustomPage, CustomView, Item, Tabbar },

  data() {
    return {
      purchaseList: [],

      invalidGoodsList: [],

      totalNum: 0,
      invaildCommoditiesNum: 0,
      vaildCommoditiesNum: 0,
      loading: true,
    };
  },
  created() {
    // this.$store.dispatch("app/showLoading");

    this.getData();
  },

  Watch: {
    invalidGoodsList() {
      if (this.invalidGoodsList.length === 0) {
        this.totalNum -= this.invaildCommoditiesNum;
      }
    },
  },
  methods: {
    getData() {
      this.freshCart();
    },
    handleTotalNum() {
      this.totalNum -= 1;
    },
    freshCart() {
      getCart()
        .then(({ data }) => {
          data.purchaseList.forEach((item) => {
            item.purchaseGoodsList.forEach((item2) => {
              item2.actPrice += item2.distMarkup;
              item2.type_union = item2.goodsInfoSpecDetails.map(
                (iii) => iii.detailName
              );
              item2.goodsInfoList.forEach((item3) => {
                if (item2.partGoodsInfoId === item3.partGoodsInfoId) {
                  item2.stock = item3.stock;
                }
                item3.actPrice += item2.distMarkup;
              });
            });
          });
          this.purchaseList = data.purchaseList;
          data.invalidGoodsList.forEach((item) => {
            if (item.distMarkup) {
              item.actPrice += item.distMarkup;
              item.goodsInfoList.forEach((item2) => {
                item2.actPrice += item.distMarkup;
              });
            }
          });
          this.invalidGoodsList = data.invalidGoodsList;

          this.invaildCommoditiesNum = data.invalidGoodsList.length;
          let temp = 0;
          data.purchaseList.map((item) => {
            temp += item.purchaseGoodsList.length;
          });
          this.vaildCommoditiesNum = temp;
          this.totalNum = this.invaildCommoditiesNum + temp;
          // this.$store.dispatch("app/hideLoading");
          this.loading = false;
        })
        .catch((e) => {
          // this.$store.dispatch("app/hideLoading");
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="less" slot-scope>
</style>
